import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class FullscreenLoaderService {
  isopen$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  start() {
    this.isopen$.next(true);
  }

  stop() {
    this.isopen$.next(false);
  }
}
